<template>
  <div class="main-view">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-form inline class="inline-form">
        <el-form-item label="收款时间">
          <date-range-picker v-model="collectTime" :value="collectTime" @getChange="dateChange"></date-range-picker>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input class="search-input" v-model="searchInfo.targetMerchantId" placeholder="请输入商户编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="loading"></auth-button>
          <auth-button opt="export" :plain="true" @click.native="exportClick" label="导出" :loading="exportLoading"></auth-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- table -->
    <el-card class="tableCard" shadow="never">
      <el-col class="amount">
        <span class="label">总收款金额：</span>{{totalAmount}}
      </el-col>
      <el-table
        stripe
        style="width:100%;"
        v-loading="loading"
        :data="list"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="createTime"
          label="入账时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantId"
          label="付款方编号(商户编号)"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户名称"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="收款金额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            {{ (scope.row.amount / 100).toFixed(2) }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { pageIncome, exportIncomes } from '@/api/subAccount.js'
import { parseTime } from '@/utils/formatTime'

export default {
  name: 'CollectionRecord',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = parseTime(new Date(), '{y}-{m}-{d}') + ' 23:59:59'
    const toadyZero = new Date(new Date().setDate(1))
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d}') + ' 00:00:00'
    return {
      loading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        beginTime: '',
        endTime: '',
        targetMerchantId: ''
      },
      collectTime: [todayZeroStr, todayStr],
      list: [],
      totalAmount: '--',
      exportLoading: false
    }
  },
  mounted () {
    this.getDefaultData()
  },
  methods: {
    /**
     * @description 初始加载数据方法
     */
    getDefaultData () {
      this.searchClick()
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick()
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick () {
      this.searchInfo.beginTime = this.collectTime && this.collectTime[0] ? this.collectTime[0] : ''
      this.searchInfo.endTime = this.collectTime && this.collectTime[1] ? this.collectTime[1] : ''
      if (!this.searchInfo.beginTime || !this.searchInfo.endTime || this.searchInfo.beginTime.substring(0, 8) !== this.searchInfo.endTime.substring(0, 8)) {
        this.$message({
          showClose: true,
          message: '目前不支持跨月查询，请检查后重试',
          type: 'error'
        })
        return
      }
      this.loading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, this.paginations))
      pageIncome(params).then(response => {
        this.loading = false
        if (response.error_code === '0') {
          this.list = response.data.list
          this.paginations.count = response.data.totalCount
          this.totalAmount = (response.data.totalAmount / 100).toFixed(2)
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error',
            showClose: true
          })
        }
      })
    },
    dateChange (value) {
      this.collectTime = value
    },
    exportClick () {
      this.searchInfo.beginTime = this.collectTime && this.collectTime[0] ? this.collectTime[0] : ''
      this.searchInfo.endTime = this.collectTime && this.collectTime[1] ? this.collectTime[1] : ''
      if (!this.searchInfo.beginTime || !this.searchInfo.endTime || this.searchInfo.beginTime.substring(0, 8) !== this.searchInfo.endTime.substring(0, 8)) {
        this.$message({
          showClose: true,
          message: '目前不支持跨月导出，请检查后重试',
          type: 'error'
        })
        return
      }
      this.exportLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 11,
        moduleName: '乐云付',
        menuName: '收款记录'
      }))
      exportIncomes(params).then(response => {
        this.exportLoading = false
        if (parseInt(response.result_cde) === 0) {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success',
            showClose: true
          })
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error',
            showClose: true
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.sum-view {
  margin: 10px;
  text-align: center;
  font-size: 14px;
  display: flex;
  justify-items: center;
  justify-content: space-around;
}
.sum-item-title {
  font-weight: 700;
  margin-bottom: 30px;
}
.amount {
  height: 40px;
  line-height: 40px;
  .label {
    padding-left: 20px;
    color: #000;
  }
}
</style>
